import { useNavigate } from '@tanstack/react-router';
import { Button } from '@/components/Button';
import Loading from '@/components/Loading';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import useFetchJobSourcesServices from '../api/useFetchJobSourcesServices';
import LinkedAccountSourceMethodSelect from '../components/LinkedAccountSourceMethodSelect';
import { findGroupServices, findServiceEntry } from '../utils/serviceGroup';

type Props = {
  groupKey: string;
};

export default function LinkedAccountGroupTemplate({ groupKey }: Props) {
  const navigate = useNavigate();
  const { data: services, isPending } = useFetchJobSourcesServices();

  const backToSelection = () => navigate({ to: '/agent/linked_accounts/new' });

  if (isPending) {
    return (
      <div className="flex h-[calc(100vh_-_200px)] items-center justify-center">
        <Loading size="medium" />
      </div>
    );
  }

  const entry = findServiceEntry(groupKey);

  if (!entry) {
    return (
      <div className="flex h-[calc(100vh_-_200px)] flex-col items-center justify-center gap-md">
        <p className="text-body-md">指定された連携先が見つかりませんでした。</p>
        <Button type="button" color="secondary" onClick={backToSelection}>
          <MdKeyboardArrowLeft size={20} />
          アカウント選択へ戻る
        </Button>
      </div>
    );
  }

  return (
    <div className="flex w-full justify-center">
      <LinkedAccountSourceMethodSelect
        groupName={entry.name}
        services={findGroupServices(services ?? [], entry.name)}
        onSelect={(selected) =>
          navigate({
            to: '/agent/linked_accounts/new/$sourceType',
            params: { sourceType: selected.source_type },
          })
        }
        onBack={backToSelection}
      />
    </div>
  );
}
